import { render, staticRenderFns } from "./InventariosProductos.vue?vue&type=template&id=38d8b569&"
import script from "./InventariosProductos.vue?vue&type=script&lang=js&"
export * from "./InventariosProductos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports